import { useQueryClient } from '@tanstack/react-query'

import type { AccountUsersNotificationEvent } from '@fv/models'

import { notificationKeys } from './queries'

export const useNotificationsLiveEventsHandler = () => {
  const queryClient = useQueryClient()

  return (event: AccountUsersNotificationEvent) => {
    queryClient.setQueriesData<number>(
      { queryKey: notificationKeys.defaultCounts() },
      prev => {
        if (prev === undefined) return prev
        return prev + 1
      },
    )
    queryClient.invalidateQueries({ queryKey: notificationKeys.all })
    queryClient.invalidateQueries({
      queryKey: notificationKeys.filteredCountBase(),
    })
  }
}
